import styled from "@emotion/styled";

export const HeaderStyled = styled.div`
  position: sticky;
  top: 0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
    padding: 1rem 5% 1rem 7%;
  height: 100px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  font-family: "Futura PT Book";
  box-sizing: border-box;
  background: #fff;
  z-index: 999;
  .logo {
    height: 60px;
  }

  a {
    text-decoration: none;
    color: #09507f;
    text-transform: uppercase;
    font-size: 16px;
  }

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background: linear-gradient(
      103deg,
      #ffd27d 0%,
      #87c674 15%,
      #139e87 62%,
      #09507f 100%
    );
    z-index: 9999;
  }

  @media (max-width: 1024px) {
    height: 80px;
    .logo {
      height: 40px;
    }
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  img:hover {
    cursor: pointer;
  }
`;

export const HeaderTitleItems = styled.div`
  display: flex;
`;

export const HeaderTitleItem = styled.div`
  position: relative;
  padding: 15px;
  a:hover {
    text-decoration: underline !important;
  }
`;

export const RightSection = styled.div`
  a:hover {
    color: #00b49d;
  }
  button {
    border-radius: 10vw;
    transition: all 0.1s ease-in-out;
    border: 3px solid #ffd27d;
    background: #ffd27d;
    margin-left: 15px;
    &:hover {
      animation: scale 0.2s ease-in-out;
      background: transparent;
    }
    @keyframes scale {
      from {
        transform: scale(1);
      }
      to {
        transform: scale(1.1);
      }
    }
  }

  @media (max-width: 1024px) {
    button {
      margin-left: 0;
    }
  }
`;

export const Drawer = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  height: 200px;
  background-color: white;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-out 0s;
  z-index: 10;
  font-family: "Futura PT Book";
  box-sizing: border-box;
  &.open {
    top: 100px;
    transition: all 0.3s ease-out 0s;
    pointer-events: auto;
    opacity: 1;
    visibility: visible;
  }

  &.close {
    top: 200px;
    opacity: 0;
    visibility: hidden;
  }
`;

export const DrawerContent = styled.div`
  padding: 20px;
  display: flex;
  justify-content: center;
  gap: 200px;
  align-items: flex-start;
  .link-title {
    color: #00b49d;
    font-size: 18px;
    text-decoration: underline;
    font-weight: 500;
    text-transform: capitalize;
  }
  .link-title:hover {
    color: #09507f;
  }
  a {
    text-decoration: none;
    color: #09507f;
    text-transform: uppercase;
    font-size: 16px;
  }
  a:hover {
    color: #00b49d;
  }
`;

export const DrawerLink = styled.div``;

export const DrawerLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MobileDrawerSection = styled.div`
    width: 100%;
    height: calc( 100vh - 80px);
    background: #fff;
    padding: 8%;
    display: flex;
    flex-direction: column;
    z-index: 2;
    position: absolute;
    top: 80px;
    right: 0;
    font-family: "Futura PT Book";
    box-sizing: border-box;
    &.open {
      visibility: visible;
      opacity: 1;
      transition: visibility 0s, opacity 0.5s linear;
    }

    &.close {
        visibility: hidden;
        opacity: 0;
        transition: visibility 0.6s, opacity 0.5s linear;
    }
`;

export const MobileDrawerTitle = styled.div`
    font-size: 18px;
    padding: 15px 5px;
    background:#fff;
    color:#09507f;
    display: flex;
    justify-content: sapce-between;
    padding-right: 50px;
`

export const Accordion = styled.div`
    &.accordion-open {
      visibility: visible;
      height: 100%;
      opacity: 1;
      transition:height 0.6s, opacity 0.6s linear;
    }

    &.accordion-close {
      visibility: hidden;
      height: 0;
      opacity: 0;
      transition: height 0.6s, visibility 0.3s, opacity 1s linear;
    }
`

export const AccordionLink = styled.div`
  margin-bottom: 15px;
`

export const AccordionLinks = styled.div`
  .link-title {
    color: #00b49d;
    font-size: 18px;
    text-decoration: underline;
    font-weight: 500;
    text-transform: capitalize;
    margin-bottom: 15px;
  }
  .link-title:hover {
    color: #09507f;
  }
  a {
    text-decoration: none;
    color: #09507f;
    text-transform: uppercase;
    font-size: 16px;
    line-height: 22px;
    display: block;
  }
  a:hover {
    color: #00b49d;
  }
`
